import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, breakpoints, palette }) => ({
  header: {
    [breakpoints.down('xs')]: {
      marginTop: spacing(8)
    },
    marginBottom: spacing(3)
  },
  contentTotal: {
    color: palette.text.secondary,
    marginLeft: spacing(1)
  },
  gridHeader: {
    borderBottom: '1px solid #E0E0E0',
    padding: spacing(2.2, 2, 2.2, 2),
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  tablePaper: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: spacing(0, 1.5),
    minHeight: 240
  },
  tableHead: {
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.25
  },
  dateUpdatedHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      marginRight: spacing(1)
    }
  },
  loadMoreBtn: {
    margin: spacing(5, 0)
  },
  loadingAnimation: {
    minHeight: 200
  },
  emptyList: {
    minHeight: spacing(30),
    color: palette.text.secondary
  },
  items: {
    padding: spacing(1.3, 2, 1.3, 2)
  }
}))
